import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
} from "@mui/material";

import { fetchInProgressRequests } from "../../../contents/redux/actions/trackActions"; // Import the action to fetch in-progress requests

const InProgress = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { inProgress, isLoading, fetchInProgressError } = useSelector((state) => state.track); // Access the in-progress requests from the Redux store

  console.log("In-progress state:", inProgress); // Debugging: Log the in-progress state

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Fetch in-progress requests on component mount
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    //console.log("in progress: ", fetchInProgressRequests);
    dispatch(fetchInProgressRequests(userId));
  }, [dispatch]);

  // Pagination
  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Paginated in-progress requests
  const paginatedRequests = inProgress.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (isLoading) {
    return <div>Loading...</div>; // Display a loading message
  }

  if (fetchInProgressError) {
    return <div>Error: {fetchInProgressError}</div>; // Display an error message
  }

  return (
    <div className="component-wrapper">
      <div className="component-title">In-Progress Requests</div>
      <div className="wrapper">
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>Request Type</TableCell>
                <TableCell>Requester</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date Created</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRequests.map((request, index) => (
                <TableRow key={request.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{request.requestType || "N/A"}</TableCell>
                  <TableCell>{request.requester || "N/A"}</TableCell>
                  <TableCell>{request.statusName || "In Progress"}</TableCell>
                  <TableCell>
                    {request.createdOn
                      ? new Date(request.createdOn).toLocaleDateString()
                      : "N/A"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={inProgress.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
          />
        </TableContainer>
      </div>
    </div>
  );
};

export default InProgress;
